import { GET_USER } from '../Constants/user.constants';

const initalState = {
    userInfo: {}
};

export default (state = initalState, action) => {
    switch (action.type) {
        case GET_USER:
            return {
                userInfo: action.data
            };
        default:
            return state;
    }
};
